// extracted by mini-css-extract-plugin
export var backdropBlur = "_el-0";
export var contentCard = "_el-5";
export var frame = "_el-2";
export var image = "_el-4";
export var imagePane = "_el-3";
export var modal = "_el-1";